var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "q-list",
        { attrs: { dense: "" } },
        [
          _vm.schema.header
            ? _c("q-list-header", [_vm._v(_vm._s(_vm.schema.header))])
            : _vm._e(),
          _vm._l(_vm.schema.fields, function(field) {
            return _c(
              "div",
              { key: field.name },
              [
                field.type === "text" ||
                field.type === "password" ||
                field.type === "textarea"
                  ? _c(
                      "q-item",
                      [
                        _c("q-item-side", {
                          attrs: { icon: field.icon, color: "primary" }
                        }),
                        _c(
                          "q-item-main",
                          [
                            _c("q-item-tile", { attrs: { label: "" } }, [
                              _vm._v(_vm._s(_vm.data[field.name]))
                            ]),
                            field.helper !== ""
                              ? _c("q-item-tile", { attrs: { sublabel: "" } }, [
                                  _vm._v(_vm._s(field.label))
                                ])
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                field.type === "bool"
                  ? _c(
                      "q-item",
                      [
                        _c("q-item-side", {
                          attrs: { icon: field.icon, color: "primary" }
                        }),
                        _c(
                          "q-item-main",
                          [
                            _c(
                              "q-item-tile",
                              { attrs: { label: "" } },
                              [
                                _c(
                                  "q-field",
                                  [
                                    _c("q-toggle", {
                                      attrs: { label: field.label },
                                      model: {
                                        value: _vm.data[field.name],
                                        callback: function($$v) {
                                          _vm.$set(_vm.data, field.name, $$v)
                                        },
                                        expression: "data[field.name]"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            field.helper !== ""
                              ? _c("q-item-tile", { attrs: { sublabel: "" } }, [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(field.helper) +
                                      "\n          "
                                  )
                                ])
                              : _vm._e()
                          ],
                          1
                        ),
                        _c("q-item-side", { attrs: { right: "" } })
                      ],
                      1
                    )
                  : _vm._e(),
                field.type === "separator" ? _c("q-item-separator") : _vm._e()
              ],
              1
            )
          }),
          _c("q-item-separator", { attrs: { inset: "" } }),
          _vm.schema.buttons.length > 0
            ? _c(
                "q-item",
                [
                  _c(
                    "q-item-main",
                    [
                      _c(
                        "q-btn-group",
                        { attrs: { rounded: "" } },
                        _vm._l(_vm.schema.buttons, function(button) {
                          return _c("q-btn", {
                            key: button.buttonid,
                            attrs: {
                              rounded: "",
                              icon: button.icon,
                              color: button.color,
                              label: button.label
                            },
                            on: {
                              click: function($event) {
                                return _vm.buttonClick(button)
                              }
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }